import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { P } from 'stile-shared/src/components/2020/common/Primitives';

import { PageLayout } from 'templates/2020/PageLayout';
import { SEO } from 'templates/2020/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Sample Lab Guide"
      description="Download Stile's Sample Lab Guide"
      slug={props.location.pathname}
    />
  );
}

function LabKitsPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Sample Lab Guide"
        id="LAB_GUIDE"
        subtitle=""
        description="Complete the form below to download a sample lab guide. One of our Curriculum Specialists will contact you to guide you through it and answer your questions."
        redirectUrl="https://stileapp.com/go/lgenergyconservation"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/lab-kits/sample-lab-kits.png"
            alt=""
          />
        }
      >
        <P>
          Every Stile unit comes with a Lab Guide for teachers. The guide provides step-by-step
          instructions for every lab, access to demo videos of us doing the lab, sample results and
          risk assessments.
        </P>
      </ResourceAccessBlock>
      <CtaBlock />
    </PageLayout>
  );
}

export default LabKitsPage;
